import React, { type FC } from 'react';
import { MdError } from 'react-icons/md';

const LegallyRequiredBadge: FC = () => {
  return (
    <div
      className="inline-flex items-center gap-2 px-3 py-1 rounded-full ml-2"
      style={{
        background: 'var(--Button-Background-Status-Error-Disabled, #FFEDEB)',
      }}
    >
      <MdError
        size={18}
        style={{ color: 'var(--Button-Icon-Status-Error-Regular, #F45A61)' }}
        aria-label="Legally required icon"
      />
      <span
        style={{
          color: 'var(--Button-Text-Status-Error-Regular, #F45A61)',
          fontSize: 14,
          fontFamily: 'Codec Warm',
          fontWeight: 400,
          lineHeight: '21px',
        }}
      >
        Legally required
      </span>
    </div>
  );
};

export default LegallyRequiredBadge;
